import { GoogleTagManagerScript } from './googleTagManager/googleTagManagerScript'
import { useTrackConversion } from './googleTagManager/trackConversion'

export const MarketingTracking = {
  Script: GoogleTagManagerScript,
  use: useTrackConversion,
}
